/* CUSTOM 2026-08-06 — Bedienleiste von Autoplay-Videos erst auf Klick zeigen.

   Ausgangslage: snippets/video.liquid lieferte Videos mit controls: true aus. Startet ein Video
   beim Hineinscrollen automatisch, blendet der Browser die native Leiste (Stop, Zeitleiste,
   Lautstaerke) kurz ein und nach ein paar Sekunden Inaktivitaet wieder aus. Dieses Aufblitzen
   war das Problem.

   Jetzt kommen Autoplay-Videos ohne Leiste. Klickt jemand hinein, wird sie eingeblendet — ab
   dann bleibt sie, das Video verhaelt sich wie ein normaler Player.

   Delegiert am Dokument, damit auch Videos erfasst werden, die spaeter ins DOM kommen:
   Das Theme laedt sie verzoegert aus einem <template>, sobald sie in Sichtweite geraten.
*/
(() => {
  if (window.__customVideoControls) return;
  window.__customVideoControls = true;

  document.addEventListener(
    'click',
    (ereignis) => {
      const behaelter = ereignis.target.closest('video-media[autoplay]');
      if (!behaelter) return;

      const video = behaelter.querySelector('video');
      if (!video || video.hasAttribute('controls')) return;

      video.setAttribute('controls', '');
      /* Der Klick galt dem Aufdecken der Leiste, nicht dem Pausieren — sonst haelt das Video
         im selben Moment an, in dem die Leiste erscheint. */
      if (video.paused) video.play().catch(() => {});
    },
    true
  );
})();
